export default __webpack_public_path__ + "static/media/session-switch.7899ec00.svg";